import { Input } from '../../../../atoms/Input'
import { ChangeEventHandler } from 'react'
import { useDonationFormContext } from '../../DonationFormProvider'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { Field } from '@web/components/atoms/Field'
import { InputProps } from '@chakra-ui/react/input'

type EmailInputProps = InputProps & {
  id: string
  onChange: ChangeEventHandler<HTMLInputElement>
  value: string
  label: string
  isError?: boolean
  errorMessage?: string
  hideLabel?: boolean
}

export const TEXT_COLOR_TO_HEX: Record<string, string> = {
  dark: '#000',
  light: '#FFF',
}

const EmailInput = ({ hideLabel, label, ...props }: EmailInputProps) => {
  const error = useDonationFormContext(({ errors }) => errors.email)
  const settings = useDonationFormContext((state) => state.settings)
  const textColor = useColorWithOpacity(settings?.styles?.textColor, '1', '#000000')

  return (
    <Field
      {...(hideLabel
        ? {}
        : {
            label,
            required: props.required,
          })}
      helperText={
        settings.styles?.options?.hasEmailCaptionText === false
          ? ''
          : (settings.styles?.options?.emailCaptionText ?? "We'll email your tax receipt and donation details")
      }
      helperTextColor={TEXT_COLOR_TO_HEX[textColor] ?? textColor}
      invalid={!!error}
      errorText={error as string}
    >
      <Input {...props} data-testid="donation-email" placeholder="Enter email" type="Email" name="email" />
    </Field>
  )
}

export default EmailInput
